import * as types from './activeTypes';

export const loadRating = (field = null, list = []) => {
    return {
        type: types.RATING_LOAD,
        field,
        list,
    };
};
